import axios from "axios";
import { humanizeError } from "@/lib/errorMessages";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth via cookie httpOnly `access_token` (impostato dal backend a login).
// SEC-004: rimosso il fallback JWT in localStorage (XSS exposure).
// Il fire-and-forget load() risolve i timing issues precedenti.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Compat: helper no-op mantenuti perché ancora referenziati (AuthContext/AuthCallback).
// Non toccano più localStorage — solo backward-compatibility per non rompere gli import.
export const saveToken = () => {};
export const clearToken = () => {
  try { localStorage.removeItem("epicflow_access_token"); } catch (_) {}
};
export const getToken = () => null;

// Interceptor 401: se la sessione è scaduta (o mai iniziata) durante una
// sessione staff già loggata, portiamo l'utente al /login con banner "sessione scaduta"
// invece di lasciarlo con un toast criptico. Skip per gli endpoint di auth/config.
let _redirecting = false;
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthEndpoint = url.includes("/auth/") || url.includes("/config/public");
    if (status === 401 && !isAuthEndpoint && !_redirecting) {
      const path = typeof window !== "undefined" ? window.location.pathname : "/";
      // Solo se siamo già dentro un'area protetta (admin/insegnante/area-cliente)
      const inProtectedArea = /^\/(admin|insegnante|area-cliente|dashboard)/.test(path);
      if (inProtectedArea) {
        _redirecting = true;
        try { localStorage.removeItem("epicflow_access_token"); } catch (_) {}
        // piccolo delay per lasciare che eventuali toast si stampino, poi redirect
        setTimeout(() => {
          window.location.assign(`/login?expired=1&next=${encodeURIComponent(path)}`);
        }, 300);
      }
    }
    return Promise.reject(error);
  },
);

export default api;

export function formatApiError(err) {
  return humanizeError(err);
}
